import { createContext, useContext } from 'react';
import type { IUser } from 'configcat-react';

const ConfigCatUserContext = createContext<IUser | undefined>(undefined);

const useConfigCatUser = (): IUser | undefined => useContext(ConfigCatUserContext);

export { ConfigCatUserContext, useConfigCatUser };
